<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter, useStore } from 'dashboard/composables/store.js';
import wootConstants from 'dashboard/constants/globals';
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['changeFilter']);

const store = useStore();
const { t } = useI18n();

const { updateUISettings } = useUISettings();

const chatStatusFilter = useMapGetter('getChatStatusFilter');
const chatSortFilter = useMapGetter('getChatSortFilter');

const currentStatusFilter = computed(
  () => chatStatusFilter.value || wootConstants.STATUS_TYPE.OPEN
);

const currentSortBy = computed(
  () => chatSortFilter.value || wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC
);

const isNewestFirst = computed(
  () => currentSortBy.value === wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC
);

const sortToggleIcon = computed(() =>
  isNewestFirst.value
    ? 'i-lucide-arrow-down-wide-narrow'
    : 'i-lucide-arrow-up-narrow-wide'
);

const sortToggleTooltip = computed(() =>
  isNewestFirst.value
    ? t('CHAT_LIST.SORT_ORDER_ITEMS.last_activity_at_asc.TEXT')
    : t('CHAT_LIST.SORT_ORDER_ITEMS.last_activity_at_desc.TEXT')
);

const saveSelectedFilter = value => {
  updateUISettings({
    conversations_filter_by: {
      status: currentStatusFilter.value,
      order_by: value,
    },
  });
};

const toggleSort = () => {
  const newSort = isNewestFirst.value
    ? wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_ASC
    : wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC;
  emit('changeFilter', newSort, 'sort');
  store.dispatch('setChatSortFilter', newSort);
  saveSelectedFilter(newSort);
};
</script>

<template>
  <NextButton
    v-tooltip.top="sortToggleTooltip"
    :icon="sortToggleIcon"
    slate
    faded
    xs
    @click="toggleSort"
  />
</template>
